angular.module('mymessages').factory('MyMessagesService',
    ['$sce', '$q', 'aprgettext', 'PatientPortalStorageRepository', 'MyMessagesRepository', 'storage','PatientSettingsService',
        function ($sce, $q, gettext, PatientPortalStorageRepository, MyMessagesRepository, storage, PatientSettingsService) {

            'use strict';

            function setMessageSettingsStorage(settings, patientId) {
                storage.set('messageSettings' + patientId, settings);
            }

            function getMessageSettingsStorage(patientId) {
                return storage.get('messageSettings' + patientId);
            }

            function  isAttachmentAllowed()
            {
                var featureList = PatientSettingsService.getPatientFeatures();
                return featureList.PatientMessageAttachment.IsActive;
            }



            function indexAppointmentsQuestion() { return 0; }
            function indexBillingQuestion() { return 1; }
            function indexDemographicsQuestion() { return 2; }
            function indexGeneralQuestion() { return 3; }
            function indexLoginAssistanceQuestion() { return 4; }
            function indexPrescriptionRxQuestion() { return 5; }
            function indexAllMessages() { return 6; }

            function getMessageSubTypes() {
                var messageSubTypes = [
                    {Id: 'FD4E2C5D-29C6-4A51-BD20-551D6ED90843', Index: indexAppointmentsQuestion(), Name: gettext('Appointments Question')},
                    {Id: '73366BA8-0149-47E0-875B-CB12BB4CB250', Index: indexBillingQuestion(), Name: gettext('Billing Question')},
                    {Id: 'DFFB40D0-2318-41A9-8EEF-94C58BABB9B9', Index: indexDemographicsQuestion(), Name: gettext('Demographics Question')},
                    {Id: '9AF1089B-E98B-4758-80F8-0435B143426D', Index: indexGeneralQuestion(), Name: gettext('General Question')},
                    {Id: 'ECA5B8A3-8371-4C08-BF43-386BAC737D3F', Index: indexLoginAssistanceQuestion(), Name: gettext('Login Assistance Question')},
                    {Id: 'E94B7146-407D-4F92-A393-DE8429B7BFBF', Index: indexPrescriptionRxQuestion(), Name: gettext('Prescription Rx Question')},
                    {Id: '00000000-0000-0000-0000-000000000000', Index: indexAllMessages(), Name: gettext('All Messages')}
                ];

                return messageSubTypes;
            }


            function cleanMessageHeader(text) {
                var returnText = text.replace('Patient Question -', '');
                returnText = returnText.replace('Patient Message -', '');

                var re = new RegExp('RE :', 'g');
                returnText = returnText.replace(re, 're :');

                returnText = returnText.trim();
                return returnText;
            }


            function removeLineBreaks(text) {
                var returnText = text;

                var re = new RegExp('\r', 'g');
                returnText = returnText.replace(re, '');

                re = new RegExp('\n', 'g');
                returnText = returnText.replace(re, '');

                re = new RegExp('<br>', 'g');
                returnText = returnText.replace(re, ' ');

                re = new RegExp('<br/>', 'g');
                returnText = returnText.replace(re, ' ');

                re = new RegExp('<p>', 'g');
                returnText = returnText.replace(re, '');

                re = new RegExp('</p>', 'g');
                returnText = returnText.replace(re, ' ');

                return returnText;
            }


            function replaceLineBreaksWithHtmlLineBreak(text) {
                var returnText = text;

                var re = new RegExp('\r\n', 'g');
                returnText = returnText.replace(re, '<br/>');

                re = new RegExp('\n', 'g');
                returnText = returnText.replace(re, '<br/>');

                return returnText;
            }

            function getNewMessages() {
                var activePatient = PatientPortalStorageRepository.getActivePatient();
                var messageFilter = {
                    MessageSubTypeId: '00000000-0000-0000-0000-000000000000',  // pass null
                    SearchSendReceivedMessages: 'Received',
                    SortDirection: 'desc',
                    NumberOfMessages: 250,
                    SearchNewOldMessages: 'New'
                };

                return MyMessagesRepository
                    .getMessages(activePatient.id, messageFilter)
                    .then(function (data) {
                        var messages = _(data)
                            .forEach(function (msg) {
                                msg.MessageHeaderText = cleanMessageHeader(msg.MessageHeaderText);
                                msg.MessageBodyText = $sce.trustAsHtml(removeLineBreaks(msg.MessageBodyText));

                                if (msg.LastReadByPortalDate == null) {
                                    msg.NewMessage = true;
                                }
                                else {
                                    msg.NewMessage = false;
                                }
                            });
                        return messages;
                    });
            }

            function getMessageSettings(userId) {
                var messageSettings = getMessageSettingsStorage(userId);

                if (messageSettings != null) {
                    return $q.when(messageSettings);
                } else {
                    return MyMessagesRepository
                        .getMessageSettings(userId)
                        .then(function (data) {
                            setMessageSettingsStorage(data, userId);
                            return data;
                        });
                }
            }


            return {
                cleanMessageHeader: cleanMessageHeader,
                removeLineBreaks: removeLineBreaks,
                replaceLineBreaksWithHtmlLineBreak: replaceLineBreaksWithHtmlLineBreak,
                getMessageSubTypes: getMessageSubTypes,
                indexAllMessages: indexAllMessages,
                indexGeneralQuestion: indexGeneralQuestion,
                getNewMessages: getNewMessages,
                getMessageSettings: getMessageSettings,
                isAttachmentAllowed : isAttachmentAllowed
            };

    }]);